const breakPoints = {
  xs: 480,
  sm: 768,
  md: 992,
  lg: 1200,
};

const SHORTEST_INTL_PHONE_LENGTH = 7;

const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

const skillLevels = {
  beginner: 32,
  intermediate: 33,
  expert: 66,
};

const RECENT_JOBS_COOKIE = 'recentJobs';

const PORTFOLIO_AD_ROTATION_MILLISECONDS = 20000;

const TODAY = new Date();

const DEFAULT_LOCALE = 'en-US';

// Undock constants

const DEFAULT_UNDOCK_MEETING_DURATION = 15;
const DEFAULT_UNDOCK_TIME_ZONE = 'Europe/London';
const DEFAULT_UNDOCK_AVAILABILITY_TYPE = 'only-free';
const INITIAL_UNDOCK_AVAILABILITY_TIME_PERIOD = 4;
const DEFAULT_UNDOCK_AVAILABILITY_TIME_PERIOD = 30;
const DEFAULT_UNDOCK_SELECTED_DAY = 0;

// Pinder
const DEFAULT_PENDING_PITCHES_TO_LOAD = 3;

export {
  RECENT_JOBS_COOKIE,
  breakPoints,
  DEFAULT_LOCALE,
  SHORTEST_INTL_PHONE_LENGTH,
  skillLevels,
  TODAY,
  DEFAULT_UNDOCK_MEETING_DURATION,
  DEFAULT_UNDOCK_TIME_ZONE,
  DEFAULT_UNDOCK_AVAILABILITY_TYPE,
  DEFAULT_UNDOCK_AVAILABILITY_TIME_PERIOD,
  DEFAULT_UNDOCK_SELECTED_DAY,
  INITIAL_UNDOCK_AVAILABILITY_TIME_PERIOD,
  PORTFOLIO_AD_ROTATION_MILLISECONDS,
  DEFAULT_PENDING_PITCHES_TO_LOAD,
  MILLISECONDS_PER_DAY,
};
